
import { getReceipt } from "@/api/order.js"
export default {
  components: {},
  layout: "onlyContent",
  props: {},
  data() {
    return {
      url: ""
    }
  },
  computed: {},
  watch: {},
  created() {},
  async mounted() {
    const { orderId } = this.$route.query
    try {
      const res = await getReceipt({
        param: JSON.stringify({
          orderId
        })
      })
      if (res && res.data) {
        const url = `data:application/pdf;base64,${res.data}`
        this.url = url
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods: {}
}
